/// <amd-module name="SuiteCommerce.ItemRecSys.WidgetCct.WidgetSettings"/>
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
define("SuiteCommerce.ItemRecSys.WidgetCct.WidgetSettings", ["require", "exports", "Utils", "Profile.Model", "SuiteCommerce.ItemRecSys.Scenario", "SuiteCommerce.ItemRecSys.ScenarioService", "LiveOrder.Model"], function (require, exports, Utils, ProfileModel, Scenario_1, ScenarioService_1, LiveOrderModel) {
    "use strict";
    var _a;
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WidgetSettings = exports.FallbackType = void 0;
    var FallbackType;
    (function (FallbackType) {
        FallbackType[FallbackType["POPULAR_ITEMS"] = 1] = "POPULAR_ITEMS";
        FallbackType[FallbackType["NEW_ITEMS"] = 2] = "NEW_ITEMS";
        FallbackType[FallbackType["NONE"] = 3] = "NONE";
    })(FallbackType || (exports.FallbackType = FallbackType = {}));
    var FallbackRequestParam = (_a = {},
        _a[FallbackType.POPULAR_ITEMS] = 'popitems',
        _a[FallbackType.NEW_ITEMS] = 'newitems',
        _a[FallbackType.NONE] = 'none',
        _a);
    var WidgetSettings = /** @class */ (function () {
        function WidgetSettings(cctSettingsObj, container) {
            this.headerText = '';
            this.numberOfItems = 10;
            this.fallbackType = FallbackType.POPULAR_ITEMS;
            this.fallbackHeaderText = '';
            this.cart = LiveOrderModel.getInstance();
            this.contextItemIds = [];
            if (cctSettingsObj && container) {
                this.settingsObj = cctSettingsObj;
                this.numberOfItems = this.getSetting('qty', 10);
                this.headerText = this.getSetting('heading', '');
                this.scenarioId = this.getSetting('scenario', 0);
                this.fallbackType = this.getSetting('fallback_type', FallbackType.POPULAR_ITEMS);
                this.fallbackHeaderText = this.getSetting('fallback_heading', this.headerText);
                this.shopperId = ProfileModel.getInstance().id;
                this.pdpItemInfo = container.getComponent("PDP").getItemInfo();
                this.contextItemIds = [];
                this.inModal = false;
                try {
                    this.inModal = !!container.getComponent('Layout').getCurrentView().inModal;
                }
                catch (e) { /* suppress; */ }
            }
        }
        WidgetSettings.create = function (cctSettingsObj, container) {
            return __awaiter(this, void 0, void 0, function () {
                var instance, _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            instance = new WidgetSettings(cctSettingsObj, container);
                            _a = instance;
                            return [4 /*yield*/, ScenarioService_1.ScenarioService.get().getScenarioById(instance.scenarioId)];
                        case 1:
                            _a.scenario = _b.sent();
                            instance.contextItemIds = instance.getContextItemIds();
                            return [2 /*return*/, instance];
                    }
                });
            });
        };
        WidgetSettings.prototype.getQueryItemLimit = function () {
            return this.numberOfItems * WidgetSettings.RECSYS_EXTRA_ITEMS_FACTOR;
        };
        WidgetSettings.prototype.readCookie = function (cookie) {
            var str = RegExp(cookie + "=[^;]+").exec(document.cookie);
            return decodeURIComponent(!!str ? str.toString().replace(/^[^=]+./, "") : "");
        };
        WidgetSettings.prototype.getRecentlyVisitedItems = function () {
            try {
                var cookie_ids = this.readCookie('recentlyViewedIds') || '[]';
                return JSON.parse(cookie_ids);
            }
            catch (_a) {
                console.debug('Could not parse itemIds cookie');
                /* suppress */
                return [];
            }
        };
        WidgetSettings.prototype.getContextItemIds = function () {
            if ((this.scenario.usecase == Scenario_1.RecommendationUsecase.WHO_BOUGHT_ALSO_BOUGHT || this.scenario.usecase == Scenario_1.RecommendationUsecase.ALTERNATIVE_ITEMS) && this.pdpItemInfo) {
                return [parseInt(this.pdpItemInfo.item.internalid)];
            }
            else if (this.scenario.usecase == Scenario_1.RecommendationUsecase.SESSION_RELATED_ITEMS) {
                return this.getRecentlyVisitedItems();
            }
            else if (this.scenario.usecase == Scenario_1.RecommendationUsecase.CHECKOUT_RELATED_ITEMS) {
                var strIds = this.cart.getItemsIds();
                return Array.isArray(strIds) ? strIds.map(function (id) { return parseInt(id); }) : [];
            }
            else {
                return [];
            }
        };
        WidgetSettings.prototype.getRecSysApiUrl = function () {
            var params = {
                scenarioId: this.scenarioId,
                shopperId: this.shopperId,
                limit: this.getQueryItemLimit(),
                n: SC.ENVIRONMENT.siteSettings.siteid,
                c: SC.ENVIRONMENT.companyId,
                fallback: FallbackRequestParam[this.fallbackType]
            };
            var url = Utils.addParamsToUrl(WidgetSettings.RECSYS_API_URL, params);
            var contextItemIds = this.getContextItemIds();
            contextItemIds.forEach(function (itemId) {
                url += "&itemId=".concat(itemId);
            });
            return url;
        };
        WidgetSettings.prototype.assertWidgetUsecaseOk = function () {
            this.contextItemIds = this.getContextItemIds();
            if (this.scenario.id < 0) {
                throw Error(WidgetSettings.FEATURE_DISABLED);
            }
            if (!this.scenario.isEligible) {
                throw Error(WidgetSettings.SITE_NOT_ELIGIBLE);
            }
            if (this.scenario.isInactive) {
                throw Error(WidgetSettings.SCENARIO_INACTIVE);
            }
            if ((this.scenario.usecase === Scenario_1.RecommendationUsecase.WHO_BOUGHT_ALSO_BOUGHT || this.scenario.usecase === Scenario_1.RecommendationUsecase.ALTERNATIVE_ITEMS) && this.contextItemIds && this.contextItemIds.length < 1) {
                throw Error(WidgetSettings.NOT_PDP_ADMIN_MESSAGE);
            }
            return true;
        };
        WidgetSettings.prototype.getNoRecommendationsMessage = function () {
            return this.scenario.usecase == Scenario_1.RecommendationUsecase.WHO_BOUGHT_ALSO_BOUGHT ?
                WidgetSettings.NO_RECOMMENDATIONS_ADMIN_MESSAGE_ITEM :
                WidgetSettings.NO_RECOMMENDATIONS_ADMIN_MESSAGE_SHOPPER;
        };
        WidgetSettings.prototype.getSetting = function (fieldName, defaultValue) {
            if (!this.settingsObj) {
                return null;
            }
            return Utils.trim(this.settingsObj[WidgetSettings.FIELD_NAME_PREFIX + fieldName]) || defaultValue;
        };
        WidgetSettings.prototype.contextDiffers = function (ws2) {
            return !ws2 ||
                this.headerText != ws2.headerText ||
                this.numberOfItems != ws2.numberOfItems ||
                this.shopperId != ws2.shopperId ||
                this.scenarioId != ws2.scenarioId ||
                this.fallbackType != ws2.fallbackType ||
                this.fallbackHeaderText != ws2.fallbackHeaderText ||
                this.scenario.usecase != ws2.scenario.usecase ||
                (!ws2.inModal && !this.inModal && JSON.stringify(this.contextItemIds.sort()) !== JSON.stringify(ws2.contextItemIds.sort()));
        };
        WidgetSettings.FIELD_NAME_PREFIX = 'custrecord_cctnsrs_wgt_';
        WidgetSettings.RECSYS_EXTRA_ITEMS_FACTOR = 2;
        WidgetSettings.RECSYS_API_URL = '/api/recsys/v3/recommend/items';
        WidgetSettings.SITE_NOT_ELIGIBLE = 'The site in the Settings is not eligible for intelligent item recommendations. Choose an eligible site to view recommendations.';
        WidgetSettings.SCENARIO_INACTIVE = 'The recommendation scenario selected in the Settings is inactive so no recommendations are shown. Choose an active recommendation scenario to view recommendations.';
        WidgetSettings.NOT_PDP_ADMIN_MESSAGE = 'The recommendation scenario selected in the Settings is related to items and must be placed on a product detail page. This scenario does not display recommendations on other page types.';
        WidgetSettings.NO_RECOMMENDATIONS_ADMIN_MESSAGE_ITEM = 'Item recommendations cannot be retrieved for this item. No recommendations will be displayed on this item page. Other item pages may display recommendations.';
        WidgetSettings.NO_RECOMMENDATIONS_ADMIN_MESSAGE_SHOPPER = 'Item recommendations cannot be retrieved for this shopper. No recommendations will be displayed for this shopper. Other shoppers may see recommendations.';
        WidgetSettings.FEATURE_DISABLED = 'Intelligent Recommendations feature is not enabled. Please enable it first.';
        return WidgetSettings;
    }());
    exports.WidgetSettings = WidgetSettings;
});
